export default class Gate{

    constructor(tip_cont, firma_curenta, stare_firma, tip_entitate, tip_contabilitate)
    {
        this.tip_cont = tip_cont;
        this.firma_curenta = firma_curenta;
        this.stare_firma = stare_firma;
        this.tip_entitate = tip_entitate;
        this.tip_contabilitate = tip_contabilitate;
    }

    isPFA() {
        return this.tip_entitate === 'PFA';
    }

    isPfa() {
        return this.tip_contabilitate === 'SIMPLIFICATA';
    }


    //! 1 - client , 2 - artist , 3 - galerie, 991 - administrator, 996 - webdev
    isClient()
    {
        return this.tip_cont == '1';
    }
    isArtist()
    {
        return this.tip_cont == '2';
    }
    isGalerie()
    {
        return this.tip_cont == '3';
    }
    isAdmin()
    {
        return this.tip_cont >= '991';
    }
    isWebDev()
    {
        return this.tip_cont == '996';
    }

    // returnează true dacă există o firmă curentă și stare_firma === 2 (Activă)
    firmaActiva() {

        return this.stare_firma == '2';
    }

    areFirmaSelectata() {
        const f = this.firma_curenta;
        if (typeof f === 'object' && f !== null) {
            return !!f.id;
        }
        return (
            f !== null &&
            f !== undefined &&
            f !== 0 &&
            f !== '0' &&
            f !== '' &&
            f !== 'null'
        );
    }

    //areFirmaSelectata(firma_curenta) {
    //    return firma_curenta !== null && firma_curenta !== undefined;
    //}

}